export default __webpack_public_path__ + "static/media/map.79820f81.svg";